import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { API_URL } from "../services/api";
import axios from "axios";


const RecursosHome = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [estadoOrpha, setEstadoOrpha] = useState(null);
  const [mostrarModal, setMostrarModal] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("access");

    if (!token) {
      console.warn("Token JWT no disponible.");
      return;
    }

    axios
      .get("/api/recursos/orphacode_estado/", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        setEstadoOrpha(res.data.estado);
        if (res.data.estado === "obsoleto" || res.data.estado === "no_raro") {
          setMostrarModal(true);
        }
      })
      .catch((err) => {
        console.error("Error al obtener estado del orphacode:", err);
      });
  }, []);

  const categorias = [
    {
      titulo: t("resources.associations.title"),
      descripcion: t("resources.associations.description"),
      ruta: "/recursos/asociaciones",
      imagen: "/img/recursos_asociaciones.webp",
    },
    {
      titulo: t("resources.research.title"),
      descripcion: t("resources.research.description"),
      ruta: "/recursos/proyectos",
      imagen: "/img/recursos_investigacion.webp",
    },
    {
      titulo: t("resources.centers.title"),
      descripcion: t("resources.centers.description"),
      ruta: "/recursos/centros",
      imagen: "/img/recursos_centros.webp",
    },
    {
      titulo: t("resources.functional_profile.title"),
      descripcion: t("resources.functional_profile.description"),
      ruta: "/perfil-funcional",
      imagen: "/img/recursos_perfil_diario.webp",
    },
    {
      titulo: t("resources.wordcloud.title"),
      descripcion: t("resources.wordcloud.description"),
      ruta: "/recursos/nube-palabras",
      imagen: `${API_URL.replace("/api", "")}/media/wordcloud_enfermedades.png?ts=${new Date().toISOString().slice(0,10)}`,
    },
  ];

  const handleCerrarModal = () => {
    setMostrarModal(false);
  };

  return (
    <div className="relative">
      {mostrarModal && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 flex items-start justify-center pt-24 z-50"
          role="dialog"
          aria-modal="true"
          aria-labelledby="modal-title"
        >
          <div className="bg-white p-8 rounded-2xl shadow-xl max-w-md text-center">
            <h2
              id="modal-title"
              className={`text-lg font-semibold mb-4 ${
                estadoOrpha === "obsoleto" ? "text-yellow-600" : "text-yellow-600"
              }`}
              aria-live="assertive"
            >
              {t(`error.${estadoOrpha}`).split("\n").map((linea, idx) => (
                <p key={idx} className="mb-2">{linea}</p>
              ))}
            </h2>
            <button
              onClick={() => {
                handleCerrarModal();
                navigate("/recursos");
              }}
              className="mt-4 px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition"
              aria-label={t("resources.view_resources")}
            >
              {t("resources.view_resources")}
            </button>
          </div>
        </div>
      )}

      <div className="max-w-6xl mx-auto px-6 py-12 text-center">
        <h1 className="sr-only">{t("resources.title", "Recursos disponibles")}</h1>
        <div
          id="cards-section"
          className="grid gap-6 sm:grid-cols-1 md:grid-cols-3"
          role="region"
          aria-label={t("resources.cards_region", "Categorías de recursos")}
        >
          {categorias.map((cat, index) => (
            <div
              key={cat.titulo}
              onClick={() => navigate(cat.ruta)}
              onKeyDown={(e) => {
                if (e.key === "Enter") navigate(cat.ruta);
              }}
              role="button"
              tabIndex={0}
              aria-label={`${cat.titulo}: ${cat.descripcion}`}
              className="cursor-pointer bg-white p-6 rounded-2xl shadow-md hover:shadow-xl transition duration-300 border border-gray-100 hover:border-blue-400 focus:outline-none focus:ring-2 focus:ring-blue-500 text-center"
            >
              <img
                src={cat.imagen}
                alt={`${cat.titulo} - ${cat.descripcion}`}
                className="w-full aspect-square object-cover rounded-xl mb-5"
              />
              <h3 className="text-xl font-semibold mb-3 text-blue-700">{cat.titulo}</h3>
              <p className="text-gray-600 leading-relaxed">{cat.descripcion}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default RecursosHome;
